export const BIRDVIEW_CHART_GRID_SORTABLE_ID = 'birdviewCharts'

export const BIRDVIEW_CHART_GRID_COLUMNS = 4

export const BIRDVIEW_CHART_GRID_MIN_TRACKS = 1

export const BIRDVIEW_CHART_GRID_MIN_COLUMN_SPAN = 1

export const BIRDVIEW_CHART_GRID_MIN_ROW_SPAN = 2

export const BIRDVIEW_CHART_GRID_MAX_ROW_SPAN = 4

// Must match the grid CSS: row height and gaps.
export const BIRDVIEW_CHART_GRID_COLUMN_GAP = 16

export const BIRDVIEW_CHART_GRID_ROW_GAP = 24

export const BIRDVIEW_CHART_GRID_ROW_HEIGHT = 168

export const BirdviewChartGridAxis = {
  Column: 'column',
  Row: 'row',
}

export const BIRDVIEW_CHART_GRID_SPAN_BOUNDS = {
  [BirdviewChartGridAxis.Column]: {
    max: BIRDVIEW_CHART_GRID_COLUMNS,
    min: BIRDVIEW_CHART_GRID_MIN_COLUMN_SPAN,
  },
  [BirdviewChartGridAxis.Row]: {
    max: BIRDVIEW_CHART_GRID_MAX_ROW_SPAN,
    min: BIRDVIEW_CHART_GRID_MIN_ROW_SPAN,
  },
}

export const BIRDVIEW_CHART_GRID_GAP = {
  [BirdviewChartGridAxis.Column]: BIRDVIEW_CHART_GRID_COLUMN_GAP,
  [BirdviewChartGridAxis.Row]: BIRDVIEW_CHART_GRID_ROW_GAP,
}

export const BIRDVIEW_CHART_GRID_SPAN_STEP = {
  [BirdviewChartGridAxis.Column]: 1,
  [BirdviewChartGridAxis.Row]: 1,
}
